<div class="border-1 surface-border border-round p-4">
  <em-coverage-card
    i18n-title
    title="Avenant enfant"
    i18n-tooltipText
    tooltipText="La couverture totale (permanente + temporaire) doit être au moins deux fois le montant de l'avenant pour enfant. Un enfant est considéré à charge s’il est mineur et ne perçoit pas de revenus propres, s’il est infirme quel que soit son âge, et ne peut pas subvenir à ses besoins en raison de son invalidité, ou s’il est majeur et rattaché à votre foyer fiscal.">
  </em-coverage-card>

  <div class="p-5">
    <h3 class="text-primary mb-2" i18n>Choix du produit</h3>
    <p i18n>Sélectionnez une des options suivantes.</p>
    <p-table
      [value]="products"
      [(selection)]="selectedProduct"
      (onRowSelect)="onSelect($event)"
      [scrollable]="true"
      scrollHeight="500px"
      dataKey="value"
      selectionMode="single">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 3rem"></th>
          <th i18n>Produit</th>
          <th class="text-right" i18n>Prime</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-riderProduct>
        <tr>
          <td>
            <p-tableRadioButton
              [disabled]="riderProduct === selectedProduct"
              [value]="riderProduct"></p-tableRadioButton>
          </td>
          <td>{{ riderProduct.name | emTranslate }}</td>
          @if (!isPriceLoading) {
            <td class="text-right"
              >{{ (riderProduct.price | currency: 'CAD' : 'symbol-narrow' : '1.2-2') || '--' }}
            </td>
          }
          @if (isPriceLoading) {
            <td class="text-right">
              <p-progressSpinner
                strokeWidth="6"
                [style]="{width: '100%', height: '15px'}"></p-progressSpinner>
            </td>
          }
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
